export enum TestExecutionMode {
    QUICK_RUN = 'Quick Run',
    NOT_RELEVANT = 'Not relevant',
    RUN = 'Run',
    MANUAL = 'Manual',
    LOCOTA_AUTOMATED = 'Automated',
    LOCOTA_ATTENDED = 'Attended',
    LOCOTA_EVIDENCE = 'Locota Evidence',
    VIDEO_RECORDER = 'Video Evidence'
}
